import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "card mb-5 mb-xl-10" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-header align-items-center border-0" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder mb-2 text-dark" }, "Progres"),
    /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-bold fs-7" }, " Manajemen Progres ")
  ])
], -1)
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "timeline-label" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"timeline-item\"><div class=\"timeline-label fw-bolder text-gray-800 fs-6\">1</div><div class=\"timeline-badge\"><i class=\"fa fa-genderless text-warning fs-1\"></i></div><div class=\"timeline-content d-flex\"><div class=\"row\"><div class=\"col\"><span class=\"fw-bolder text-gray-800 ps-3\">Webinar</span></div></div></div></div>", 1)
const _hoisted_7 = { class: "timeline-item" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "timeline-label fw-bolder text-gray-800 fs-6" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"timeline-item\"><div class=\"timeline-label fw-bolder text-gray-800 fs-6\">2</div><div class=\"timeline-badge\"><i class=\"fa fa-genderless text-info fs-1\"></i></div><div class=\"timeline-content fw-bolder text-gray-800 ps-3\"> Presentasi </div></div>", 1)
const _hoisted_10 = { class: "timeline-item" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "timeline-label fw-bolder text-gray-800 fs-6" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"timeline-item\"><div class=\"timeline-label fw-bolder text-gray-800 fs-6\">3</div><div class=\"timeline-badge\"><i class=\"fa fa-genderless text-success fs-1\"></i></div><div class=\"timeline-content fw-bolder text-gray-800 ps-3\"> Proposal </div></div>", 1)
const _hoisted_13 = { class: "timeline-item" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "timeline-label fw-bolder text-gray-800 fs-6" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<div class=\"timeline-item\"><div class=\"timeline-label fw-bolder text-gray-800 fs-6\">4</div><div class=\"timeline-badge\"><i class=\"fa fa-genderless text-danger fs-1\"></i></div><div class=\"timeline-content d-flex\"><span class=\"fw-bolder text-gray-800 ps-3\">Follow Up</span></div></div>", 1)
const _hoisted_16 = { class: "timeline-item" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "timeline-label fw-bolder text-gray-800 fs-6" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<div class=\"timeline-item\"><div class=\"timeline-label fw-bolder text-gray-800 fs-6\">5</div><div class=\"timeline-badge\"><i class=\"fa fa-genderless text-warning fs-1\"></i></div><div class=\"timeline-content d-flex\"><span class=\"fw-bolder text-gray-800 ps-3\">PKS</span></div></div>", 1)
const _hoisted_19 = { class: "timeline-item" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "timeline-label fw-bolder text-gray-800 fs-6" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<div class=\"timeline-item\"><div class=\"timeline-label fw-bolder text-gray-800 fs-6\">6</div><div class=\"timeline-badge\"><i class=\"fa fa-genderless text-info fs-1\"></i></div><div class=\"timeline-content d-flex\"><span class=\"fw-bolder text-gray-800 ps-3\">Pengumpulan Data Siswa</span></div></div>", 1)
const _hoisted_22 = { class: "timeline-item" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "timeline-label fw-bolder text-gray-800 fs-6" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createStaticVNode("<div class=\"timeline-item\"><div class=\"timeline-label fw-bolder text-gray-800 fs-6\">7</div><div class=\"timeline-badge\"><i class=\"fa fa-genderless text-primary fs-1\"></i></div><div class=\"timeline-content d-flex\"><span class=\"fw-bolder text-gray-800 ps-3\">Pre Implementasi</span></div></div>", 1)
const _hoisted_25 = { class: "timeline-item" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "timeline-label fw-bolder text-gray-800 fs-6" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createStaticVNode("<div class=\"timeline-item\"><div class=\"timeline-label fw-bolder text-gray-800 fs-6\">8</div><div class=\"timeline-badge\"><i class=\"fa fa-genderless text-success fs-1\"></i></div><div class=\"timeline-content d-flex\"><span class=\"fw-bolder text-gray-800 ps-3\">Tagihan</span></div></div>", 1)
const _hoisted_28 = { class: "timeline-item" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "timeline-label fw-bolder text-gray-800 fs-6" }, null, -1)
const _hoisted_30 = /*#__PURE__*/_createStaticVNode("<div class=\"timeline-item\"><div class=\"timeline-label fw-bolder text-gray-800 fs-6\">9</div><div class=\"timeline-badge\"><i class=\"fa fa-genderless text-danger fs-1\"></i></div><div class=\"timeline-content d-flex\"><span class=\"fw-bolder text-gray-800 ps-3\">Implementasi</span></div></div>", 1)
const _hoisted_31 = { class: "timeline-item" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "timeline-label fw-bolder text-gray-800 fs-6" }, null, -1)
const _hoisted_33 = /*#__PURE__*/_createStaticVNode("<div class=\"timeline-item\"><div class=\"timeline-label fw-bolder text-gray-800 fs-6\">10</div><div class=\"timeline-badge\"><i class=\"fa fa-genderless text-info fs-1\"></i></div><div class=\"timeline-content d-flex\"><span class=\"fw-bolder text-gray-800 ps-3\">After Sales</span></div></div>", 1)
const _hoisted_34 = { class: "timeline-item" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "timeline-label fw-bolder text-gray-800 fs-6" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_TableProgressWebinar = _resolveComponent("TableProgressWebinar")!
  const _component_TableProgressPresentasi = _resolveComponent("TableProgressPresentasi")!
  const _component_TableProgressProposal = _resolveComponent("TableProgressProposal")!
  const _component_TableProgressFollowUp = _resolveComponent("TableProgressFollowUp")!
  const _component_TableProgressPKS = _resolveComponent("TableProgressPKS")!
  const _component_TableProgressDataCollect = _resolveComponent("TableProgressDataCollect")!
  const _component_TableProgressPreImplementasi = _resolveComponent("TableProgressPreImplementasi")!
  const _component_TableProgressTagihan = _resolveComponent("TableProgressTagihan")!
  const _component_TableProgressImplementasi = _resolveComponent("TableProgressImplementasi")!
  const _component_TableProgressAfterSales = _resolveComponent("TableProgressAfterSales")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_TableProgressWebinar)
          ]),
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_TableProgressPresentasi)
          ]),
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createVNode(_component_TableProgressProposal)
          ]),
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createVNode(_component_TableProgressFollowUp)
          ]),
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createVNode(_component_TableProgressPKS)
          ]),
          _hoisted_21,
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createVNode(_component_TableProgressDataCollect)
          ]),
          _hoisted_24,
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _createVNode(_component_TableProgressPreImplementasi)
          ]),
          _hoisted_27,
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _createVNode(_component_TableProgressTagihan)
          ]),
          _hoisted_30,
          _createElementVNode("div", _hoisted_31, [
            _hoisted_32,
            _createVNode(_component_TableProgressImplementasi)
          ]),
          _hoisted_33,
          _createElementVNode("div", _hoisted_34, [
            _hoisted_35,
            _createVNode(_component_TableProgressAfterSales)
          ])
        ])
      ])
    ])
  ], 64))
}